const en = {
    translation: {
        accountEnding: 'Account ending in {{accountLast4}}',
        addAuthUserScreen: {
            addAsAnAuthorizedUser: 'Add as an authorized user',
            addAuthorizedUser: 'Add Authorized User below',
            birthDateInputFutureError: 'Date occurs in the future',
            birthDateInputHelpText: 'MM/DD/YYYY',
            birthDateInputInvalidDateError: 'Date must be a valid calendar date MM/DD/YYYY',
            birthDateInputPastYearError: 'Birth year occurs too far in the past',
            birthDateInputPlaceholder: "Authorized User's Date of Birth",
            birthDateInputTodayError: 'Can’t use today’s date',
            eachAuthorizedUser: 'Each Authorized User will be able to:',
            firstNameInputError: 'Please use letters only',
            firstNameInputHelpText: "Authorized User's first name",
            firstNameInputPlaceholder: 'First Name',
            lastNameInputError: 'Please use letters only',
            lastNameInputHelpText: "Authorized User's last name",
            lastNameInputPlaceholder: 'Last Name',
            legalContent: "Once added, this person will be allowed to charge on the account and will be reported to credit bureaus as an authorized user. By clicking 'Add Authorized User' below, you also understand the authorized users will not be contractually responsible for repayment of the account. Only the primary account holder will continue to be responsible to repay all charges on the account. Proceeding confirms your acceptance of these terms.",
            membershipNumber: 'Membership Number',
            nameLabel: 'Name',
            physicalCardReceived: 'Receive a physical card with their name on it in the mail, addressed to the primary account holder. The authorized user should use the card to add it to their digital wallet.',
            reportAccountHistory: 'Have the history of this account reported on their credit bureau.',
            spendAndUtilizeBenefits: 'Spend on the account and utilize benefits at the same time as the primary account holder.'
        },
        authorizedUser: 'Authorized User',
        button: {
            addAuthorizedUser: 'ADD AUTHORIZED USER',
            backToAccountServices: 'BACK TO ACCOUNT SERVICES',
            backToManageCardholders: 'BACK TO MANAGE CARDHOLDERS',
            cancel: 'CANCEL'
        },
        errorMessages: {
            accessDeniedMessageBox: {
                body: 'Please call the customer services number on the back of your card for more information.',
                title: 'We’re having trouble verifying your identity'
            },
            addPrimaryHolder: {
                extraInfo: 'Try again with another name.',
                subTitle: 'You entered the name of the Primary Cardholder who already has a card.',
                title: 'Please try again'
            },
            addressChanged: 'We cannot process your request since your address was changed in the last 30 days.',
            addressChangedSams: 'Please call the customer services number on the back of your card for more information.',
            nameChanged: 'We cannot process your request since your first name was changed in the last 30 days.',
            notEligibleAccount: 'Your account is not eligible',
            pleaseContactUs: 'Please contact us at 888-746-7726 to add additional cardholder to your account.',
            profanity: {
                title: 'Please try again',
                unapprovedName: 'The name(s) you gave us couldn’t be accepted as entered. Please make any corrections and try again.'
            },
            troubleRetrievingInformation: 'We’re having trouble retrieving your information',
            tryAgainLater: 'Please try again later.'
        },
        existingUserMessageBox: {
            existingUser: 'The user you added is already an Authorized User',
            usersList: 'Please refer to the list of users below.'
        },
        expiredMembership: {
            subtitle: 'Please contact Sam’s Club at 888-746-7726 to renew your membership before an additional cardholder can be added to your account.',
            title: 'Your Sam’s Club membership has expired'
        },
        headerSubTitle: 'You can add {{usersLimit}} more Authorized User(s) to this account.',
        headerTitle: 'Add Authorized User below',
        historyCreditBureau: 'Have the history of this account reported on their credit bureau.',
        maximumMessageBox: {
            addAnotherAuthorizedUser: 'To add another Authorized User, please remove a current Authorized User first by calling the number on the back of your card or use our <onlineChatLink>{{onlineChatText}}</onlineChatLink>',
            onlineChat: 'Online Chat',
            title: 'You have reached the maximum number of Authorized Users'
        },
        missingSomeone: 'Missing Someone?',
        newAuthorizedUser: {
            title: 'New Authorized User'
        },
        noAccountAddedMessage: 'Currently you are the only cardholder for this account.',
        noEligibleMembersFound: 'No eligible members found.',
        note: '<strong>Note:</strong> To add an Authorized User, add them to your Sam’s Club membership first.',
        notEligibleMessageBox: {
            subtitle: 'Your Sam’s Club Membership is not eligible for authorized cardholders. Please contact Sam’s club at 888-746-7726 or visit <samsLink>SamsClub.com</samsLink> to manage your membership.',
            title: 'Your Sam’s Club Membership is not eligible for authorized cardholders'
        },
        steps: {
            title: 'To add an Authorized User, add them to your Sam’s Club Membership.',
            one: 'Go to <samsLink>SamsClub.com</samsLink> to add them to your membership',
            two: 'Relaunch Manage Cardholders after adding new members at SamsClub.com'
        },
        successfulMessageBox: {
            bold: ' 7-10 business days.',
            subtitle: 'The new card will arrive at the address on file in the next',
            title: 'You’ve successfully added a new Authorized User',
            waitTimeToBeReflected: '<strong>Note:</strong> It can take up to 30 minutes for this new user to be added to your account.'
        },
        unableToProcessReq: 'Unfortunately we are unable to process your request at this time.',
        verifyMessageBox: {
            body: `We need to make sure it’s really you. <verifyUserLink>Please verify your account.</verifyUserLink>`,
            title: 'Add an Authorized User'
        }
    }
};
export default en;
